export { default } from "./LearnAboutClassRoster";
